<script setup>
import LogoIcon from "@/assets/icons/logo.svg";
import { ref } from "vue";
import MoonIcon from "@/assets/icons/moon.svg";
import SunIcon from "@/assets/icons/sun.svg";
import StarIcon from "@/assets/icons/star.svg";
import QuestionIcon from "@/assets/icons/circle-question.svg";
import { useUserStore } from "@/stores/userStore";
const theme = ref(document.documentElement.classList.contains('dark'));
const userStore = useUserStore();

const emit = defineEmits(['showModal']);

function onToggleTheme() {
    if (theme.value) {
        localStorage.setItem('theme', 'dark')
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
        localStorage.setItem('theme', 'light');
    }
}
</script>

<template>
  <header class="px-4 py-[14px] max-w-[500px] mx-auto flex items-center justify-between gap-x-2">
    <router-link to="/">
      <logo-icon width="112" height="32" class="dark:text-black text-white duration-300"/>
    </router-link>
    
    <button v-if="userStore.user?.id" @click="emit('showModal')" type="button" class="ml-auto flex items-center rounded-full pl-1 pr-2 py-1 gap-x-2 bg-grey-light dark:bg-black-light">
      <span class="gradient-main w-8 h-8 flex items-center justify-center rounded-full">
        <StarIcon width="16" height="16" />
      </span>
      <span class="leading-[12px] text-center">
        <span class="text-[13px] font-semibold text-black dark:text-white">VIP</span><br>
        <span class="text-[11px] text-black text-opacity-60 dark:text-white dark:text-opacity-60">{{ userStore.user.vip.level }} lvl</span>
      </span>
      <QuestionIcon width="16" height="16" class="text-primary"/>
    </button>
    <div class="relative">
        <input @change="onToggleTheme" v-model="theme" class="hidden peer" id="theme-switch" type="checkbox" name="theme" value="1">
        <label for="theme-switch" class="rounded-full w-[72px] bg-grey-light dark:bg-black-light block p-1 cursor-pointer duration-300">
            <span class="w-8 h-8 flex relative border border-white-pure dark:border-[#2C2C2C] rounded-full duration-300 dark:translate-x-full">
                <MoonIcon width="16" height="16" class="opacity-0 dark:opacity-100 duration-300 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
                <SunIcon width="16" height="16" class="dark:opacity-0 opacity-100 duration-300 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
            </span>
        </label>
    </div>
  </header>
</template>


<style>

</style>
